export function initModals() {
  const modals = document.querySelectorAll('dialog.modal');

  for (const modal of modals) {
    initModal(modal);
  }
}

export function initModal(modal) {
  const modalId = modal?.id;
  const modalToggles = document.querySelectorAll(
    `[data-toggle-modal="${modalId}"]`
  );

  modal?.addEventListener('close', () => {
    const elementsToKill = modal.querySelectorAll('[data-kill-on-close]');
    for (const element of elementsToKill) {
      const newElement = element.cloneNode(true);
      element.after(newElement);
      element.remove();
    }
  });

  for (const toggle of modalToggles) {
    toggle.addEventListener('click', toggleModal);
  }
}

function toggleModal(e) {
  const modalId = e.target.dataset.toggleModal;
  const modal = document.getElementById(modalId);

  if (!modal) {
    return;
  }

  const modalToggles = document.querySelectorAll(
    `[data-toggle-modal="${modalId}"]`
  );

  if (modal.open) {
    modal.close();
  } else {
    modal.showModal();
  }

  for (const toggle of modalToggles) {
    toggle.classList.toggle('is-open');
  }
}
